import { render, staticRenderFns } from "./leoAddLkNew.vue?vue&type=template&id=2e0b5084&scoped=true&"
import script from "./leoAddLkNew.vue?vue&type=script&lang=js&"
export * from "./leoAddLkNew.vue?vue&type=script&lang=js&"
import style0 from "./leoAddLkNew.vue?vue&type=style&index=0&lang=less&"
import style1 from "./leoAddLkNew.vue?vue&type=style&index=1&id=2e0b5084&lang=less&scoped=true&"
import style2 from "./leoAddLkNew.vue?vue&type=style&index=2&id=2e0b5084&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0b5084",
  null
  
)

export default component.exports